var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumberLineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 4H14.0002",
    stroke: "#1E1F26",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 8H14.0002",
    stroke: "#1E1F26",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 12H14.0002",
    stroke: "#1E1F26",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10H3C3.18586 10 3.27879 10 3.35607 10.0154C3.67343 10.0785 3.9215 10.3266 3.98463 10.6439C4 10.7212 4 10.8141 4 11C4 11.1859 4 11.2788 3.98463 11.3561C3.9215 11.6734 3.67343 11.9215 3.35607 11.9846C3.27879 12 3.18586 12 3 12C2.81414 12 2.72121 12 2.64393 12.0154C2.32657 12.0785 2.0785 12.3266 2.01537 12.6439C2 12.7212 2 12.8141 2 13V13.6C2 13.7885 2 13.8829 2.05858 13.9414C2.11716 14 2.21144 14 2.4 14H4",
    stroke: "#1E1F26",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H2.8C2.91046 2 3 2.08954 3 2.2V6M3 6H2M3 6H4",
    stroke: "#1E1F26",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberLineIcon);
export default __webpack_public_path__ + "static/media/Number_line_icon.076f0bb9927666bbe29656e338733186.svg";
export { ForwardRef as ReactComponent };